import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"
import Catalog from "../components/product-catalog/catalog"

const ProductCatalog = ({ data }) => {
  const footerData = data?.allPrismicFooter?.nodes[0]?.dataRaw
  const products = data?.allPrismicProduct?.nodes

  return (
    <Layout footerData={footerData} noHero activeSection="products">
      <Seo title="Product Catalog" />
      <Catalog products={products} />
    </Layout>
  )
}

export default ProductCatalog

export const data = graphql`
  query {
    allPrismicProduct(sort: { fields: data___header___text }) {
      nodes {
        gatsbyPath(filePath: "/products/{prismicProduct.data__header__text}")
        data {
          header {
            text
          }
          featured_color {
            url
            fluid(maxWidth: 512) {
              ...GatsbyPrismicImageFluid_noBase64
            }
            alt
          }
          specs_finish {
            text
          }
          specs_backing {
            text
          }
          specs_industry {
            text
          }
        }
      }
    }

    allPrismicFooter {
      nodes {
        dataRaw
      }
    }

    images: allFile(
      filter: { relativePath: { glob: "winner-long-blue.png" } }
      sort: { fields: name }
    ) {
      edges {
        node {
          childImageSharp {
            gatsbyImageData(width: 200)
          }
        }
      }
    }
  }
`
